module.exports = __webpack_public_path__ + "img/battleBg_icon.4bdf1bc7.png";